module.exports = __webpack_public_path__ + "media/recipes/109_old-4e284979.png";